export const DATA_REFERENCE = "DATA_REFERENCE";
export const APP_ID_KEY = "app_id";
export const CHANNEL_KEY = "channel";
export const TERMINAL_KEY = "terminal";
export const SECTOR_KEY = "sector";
export const MOVEMENT_KEY = "movement";
export const POS_TILL_KEY = "posTillNo";
export const ALLOW_ALL_STORES_KEY = "allowAllStores";
export const STORE_LIST_KEY = "storeList";
export const STORE_WAYPOINTS_KEY = "storeWaypoints";
export const KIOSK_ID_KEY = "kioskId";
export const PRINTER_USED_KEY = "printerUsed";
export const PRINTER_NAME_KEY = "printerName";
export const RECEIPT_WIDTH_KEY = "receiptWidth";
export const BOOKING_SOURCE = "bookingSource";
export const DELIVERY_ENABLED = "deliveryEnabled";
export const KIOSK_DETAILS = "kioskDetails";
export const ENABLE_SCAN_KEY = "enableScan";
export const SCAN_MODE_KEY = "scanMode"; // "scanOnly" | "scanAndBrowse"
